module.exports = __webpack_public_path__ + "assets/936046610f25e9c7d93b34de13e5c93c.png";